import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FileDown, Printer } from "lucide-react";

const PDF_FILES = [
  {
    name: "Scoresheets",
    version: "v1",
    description: "Top & Bottom half-inning tracking, pitcher log, box score, and field diagram.",
    file: "/assets/JBScoresheet.pdf",
  },
  {
    name: "Junk Ball Rules - Updated 4.26",
    version: "v1",
    description: "Everything you need to get a game going in two pages.",
    file: "/assets/Two Pager.pdf",
  },
];

export default function PrintAndPlay() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      {/* Nav */}
      <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-3 bg-slate-950/80 backdrop-blur-md border-b border-slate-800/50">
        <Link to="/" className="flex items-center gap-2 font-black text-lg tracking-tight text-white">
          <img src="/favicons32x32.png" alt="" className="w-5 h-5" />
          JUNK <span className="text-amber-400">BALL</span>
        </Link>
        <div className="flex items-center gap-4">
          <Link to="/print-and-play" className="text-xs text-white font-bold">Print & Play</Link>
          <Link to="/contact" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">Contact</Link>
          <button
            onClick={() => navigate("/online-setup")}
            className="px-3 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-black font-bold text-xs transition-all"
          >
            Play Now
          </button>
        </div>
      </nav>

      {/* Content */}
      <div className="flex-1 px-4 pt-28 pb-16 max-w-3xl mx-auto w-full">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <div className="flex items-center gap-3 mb-2">
            <Printer size={22} className="text-amber-400" />
            <h1 className="text-3xl font-black">Print & Play</h1>
          </div>
          <p className="text-slate-500 text-sm mb-10">
            Download, print, and play. Everything you need to get a game going — cards, rules, scoresheets, and more.
          </p>

          {/* Table */}
          <div className="rounded-xl border border-slate-800 overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-800 bg-slate-900/60">
                  <th className="text-left px-4 py-3 text-xs font-bold text-slate-500 uppercase tracking-widest">Name</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-slate-500 uppercase tracking-widest">Description</th>
                  <th className="text-right px-4 py-3 text-xs font-bold text-slate-500 uppercase tracking-widest">Download</th>
                </tr>
              </thead>
              <tbody>
                {PDF_FILES.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="px-4 py-12 text-center text-slate-600 text-sm">
                      Files coming soon. Check back after v1.0 release.
                    </td>
                  </tr>
                ) : (
                  PDF_FILES.map((pdf, i) => (
                    <tr key={i} className="border-t border-slate-800/60 hover:bg-slate-800/30 transition-colors">
                      <td className="px-4 py-3 font-bold text-white">{pdf.name}</td>
                      <td className="px-4 py-3 text-slate-400">{pdf.description}</td>
                      <td className="px-4 py-3 text-right">
                        <a
                          href={pdf.file}
                          download
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-black font-bold text-xs transition-all"
                        >
                          <FileDown size={12} /> PDF
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* Itch.io */}
          <div className="mt-12">
            <h2 className="text-lg font-black mb-1">Get the Full Game</h2>
            <p className="text-slate-500 text-sm mb-5">Pick up a physical or printable edition with everything included.</p>
            <iframe
              frameBorder="0"
              src="https://itch.io/embed/4470554?bg_color=0f172a&fg_color=f8fafc&link_color=f59e0b&border_color=1e293b"
              width="552"
              height="167"
              title="Junk Ball on itch.io"
              className="rounded-xl max-w-full"
            >
              <a href="https://polishednerd.itch.io/junk-ball">Junk Ball by polishednerd</a>
            </iframe>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
